import ShimmerCard from './Card';

export default ShimmerCard;
